import {
  configure,
  registerLocaleChangeHandler,
  I18n,
} from "@devforce/trailhead-client-locale";

configure((i18n) => {
  // Use "en" labels as a fallback
  i18n.fallbacks = true;
});
const translators = new WeakMap();
class LabelsAdapter {
  i18n = undefined;
  config = null;
  get options() {
    if (!this.config) return {};
    return this.config.options || {};
  }
  get labels() {
    if (!this.config) return {};
    let keys = flattenKeys(this.config.locales.en);
    return {
      ...keys.reduce(
        (labels, key) =>
          Object.assign(labels, {
            [key]: this.i18n.t("default", key, this.options[key] || {}),
          }),
        {}
      ),
    };
  }
  removeLocaleChangeHandler = () => {};
  constructor(setValue) {
    this.setValue = setValue;
  }
  connect() {
    this.setValue(this.labels);
    this.removeLocaleChangeHandler = registerLocaleChangeHandler(() => {
      this.setValue(this.labels);
    });
  }
  disconnect() {
    this.removeLocaleChangeHandler();
  }
  update(config) {
    if (!this.config || config.locales !== this.config.locales) {
      this.i18n =
        translators.get(config.locales) ||
        translators.set(config.locales, new I18n()).get(config.locales);
      this.i18n.addScope({
        default: config.locales,
      });
    }
    this.config = {
      ...config,
    };
    this.setValue(this.labels);
  }
}
function flattenKeys(object, keyPath = "") {
  return Object.keys(object).flatMap((key) => {
    if (typeof object[key] === "object") {
      return flattenKeys(object[key], `${keyPath}${key}.`);
    }
    return `${keyPath}${key}`;
  });
}

export { LabelsAdapter, flattenKeys };
